import { Link } from 'react-router-dom';
import type { Movie } from '@/mocks/movies';

export default function MovieCard({ movie }: { movie: Movie }) {
  return (
    <Link
      to={`/article/${movie.id}`}
      className="group block rounded-lg overflow-hidden bg-background-100 hover:bg-background-200 transition-all duration-300 cursor-pointer"
    >
      <div className="relative aspect-[3/4] overflow-hidden">
        <img
          src={movie.poster}
          alt={`${movie.title} - 高清影视在线观看`}
          title={`${movie.title} - 88影视网高清电影电视剧`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <div className="absolute top-2 left-2">
          <span className="px-2 py-0.5 text-[10px] font-semibold bg-primary-500 text-background-50 rounded">
            {movie.quality}
          </span>
        </div>
        {movie.isNew && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-[10px] font-semibold bg-accent-500 text-background-50 rounded">
              最新
            </span>
          </div>
        )}
        {movie.isHot && !movie.isNew && (
          <div className="absolute top-2 right-2">
            <span className="px-2 py-0.5 text-[10px] font-semibold bg-accent-500 text-background-50 rounded">
              热门
            </span>
          </div>
        )}
        <div className="absolute inset-x-0 bottom-0 h-20 bg-gradient-to-t from-black/80 to-transparent"></div>
        <div className="absolute bottom-2 left-2 right-2">
          <div className="flex items-center gap-1 text-xs text-primary-400">
            <i className="ri-star-fill text-[10px]"></i>
            <span>{movie.rating}</span>
          </div>
        </div>
      </div>
      <div className="p-3">
        <h3 className="text-sm font-medium text-foreground-50 line-clamp-1 group-hover:text-primary-400 transition-colors duration-200">
          {movie.title}
        </h3>
        <div className="flex items-center gap-2 mt-1.5">
          <span className="text-xs text-foreground-500">{movie.year}</span>
          <span className="text-xs text-foreground-600">|</span>
          <span className="text-xs text-foreground-500 line-clamp-1">{movie.genre.slice(0, 2).join('/')}</span>
        </div>
      </div>
    </Link>
  );
}